import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({
  items = ["Reasons to Stay", "Direct Booking", "Best Rates", "Super 8 Ottawa"],
  speed = 35,
}) => (
  <div className="border-y-2 border-charcoal bg-brand-yellow py-5" data-testid="editorial-marquee">
    <Marquee speed={speed} gradient={false}>
      {[...items, ...items].map((t, i) => (
        <span key={i} className="mx-6 flex items-center gap-6">
          <span className="font-display text-4xl uppercase tracking-tight text-charcoal md:text-6xl">
            {t}
          </span>
          <span className="text-3xl text-brand-red md:text-5xl">✳</span>
        </span>
      ))}
    </Marquee>
  </div>
);
